import {
  fullWidthCellStyle,
  linkColour,
  tableWidth,
} from '../pro-report-email-styles';
import { ProReportEmailFullWidthTableHeader } from './pro-report-email-common-components';

function ProReportEmailClubContact() {
  return (
    <table
      width={tableWidth}
      cellPadding={0}
      cellSpacing={0}
      style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
      role="presentation"
    >
      <ProReportEmailFullWidthTableHeader headerText="Club contact" />
      <tbody>
        <tr>
          <td
            colSpan={2}
            style={{
              ...fullWidthCellStyle,
            }}
          >
            If you require any further assistance, please liaise with your usual{' '}
            <a
              href="https://north-standard.com/our-people"
              target="_blank"
              rel="noreferrer"
              style={{
                color: linkColour,
                textDecoration: 'none',
                fontWeight: 'bold',
              }}
            >
              club contact
            </a>
            .
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default ProReportEmailClubContact;
